import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useFooter = createListQueryHook({
  queryKey: queryKeys.footer(),
  endpoint: endpoints.footer,
  config: {
    staleTime: queryConfig.staleTime.long,
  },
});

